export default {
      USERS_TYPE_LIST: [
        "Администратор", "Менеджер", "Работник", "Пользователь" 
      ],
 
  };